<!-- <div [attr.tid]="childConfig.config.controlName">
    <div class="tml-tpl-label" *ngIf="!childConfig.config.isLabelHidden">
        <label click="">{{childConfig.config.controlName}}</label>
    </div>
</div> -->

<label click=""></label>